"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports.toArray = toArray;
exports.default = Emoji;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = require("classnames");

var _classnames3 = _interopRequireDefault(_classnames2);

var _stringReplaceToArray = require("string-replace-to-array");

var _stringReplaceToArray2 = _interopRequireDefault(_stringReplaceToArray);

var _emojiRegex = require("emoji-regex");

var _emojiRegex2 = _interopRequireDefault(_emojiRegex);

var _asciiRegex = require("./asciiRegex");

var _asciiRegex2 = _interopRequireDefault(_asciiRegex);

var _aliasRegex = require("./aliasRegex");

var _aliasRegex2 = _interopRequireDefault(_aliasRegex);

var _normalizeProtocol = require("./normalizeProtocol");

var _normalizeProtocol2 = _interopRequireDefault(_normalizeProtocol);

var _unicodeToCodepoint = require("./unicodeToCodepoint");

var _unicodeToCodepoint2 = _interopRequireDefault(_unicodeToCodepoint);

var _aliases = require("../data/aliases");

var _aliases2 = _interopRequireDefault(_aliases);

var _asciiAliases = require("../data/asciiAliases");

var _asciiAliases2 = _interopRequireDefault(_asciiAliases);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var asciiAliasesRegex = (0, _asciiRegex2.default)();
var aliasesRegex = (0, _aliasRegex2.default)();
var unicodeEmojiRegex = (0, _emojiRegex2.default)(); // using em's we can ensure size matches surrounding font

var style = {
  width: "1em",
  height: "1em",
  margin: "0 .05em 0 .1em",
  verticalAlign: "-0.1em"
};

function toArray(text) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var protocol = (0, _normalizeProtocol2.default)(options.protocol);

  function replaceUnicodeEmoji(match, i) {
    if (!options.baseUrl) {
      return _react2.default.createElement("span", {
        key: i,
        style: style,
        className: options.className
      }, match);
    }

    var codepoint = (0, _unicodeToCodepoint2.default)(match, removeHelperCharacters); // if Emojione we don't want to add helper characters in the URL

    var removeHelperCharacters = options.emojione;

    if (removeHelperCharacters) {
      codepoint = codepoint.replace(/-200d/g, "").replace(/-fe0f/g, "");
    }

    var separator = options.size ? "/" : "";
    var src = "" + protocol + options.baseUrl + options.size + separator + codepoint + "." + options.ext;
    return _react2.default.createElement("img", _extends({
      key: i,
      alt: match,
      src: src,
      style: style,
      className: options.className
    }, options.props));
  }

  function replaceAsciiAliases() {
    var asciiAliasKeys = Object.keys(_asciiAliases2.default);
    var fullMatch = arguments.length <= 0 ? undefined : arguments[0];
    var edgeCase = arguments.length <= 1 ? undefined : arguments[1];
    var asciiAlias = arguments.length <= 2 ? undefined : arguments[2];
    var maybeBiggerAliasCharacters = arguments.length <= 3 ? undefined : arguments[3];

    for (var i in asciiAliasKeys) {
      var alias = asciiAliasKeys[i];
      var data = _asciiAliases2.default[alias];

      if (data.includes(asciiAlias)) {
        var isEdgeCase = edgeCase !== undefined;

        if (isEdgeCase) {
          return fullMatch; // do nothing
        }

        var isMaybePartOfBiggerAlias = maybeBiggerAliasCharacters !== undefined;

        if (!isMaybePartOfBiggerAlias) {
          return _aliases2.default[alias]; // replace with unicode
        } else if (fullMatch[0] === ":") {
          var fullMatchContent = fullMatch.slice(1, -1); // remove ":" at the beginning and end

          var isPartOfBiggerAlias = _aliases2.default[fullMatchContent] !== undefined; // ":" + fullMatchContent + ":" alias doesn't exist

          if (isPartOfBiggerAlias) {
            return fullMatch; // do nothing
          }
        }

        return "" + _aliases2.default[alias] + maybeBiggerAliasCharacters; // also return matched characters afterwards to handle them in next iteration
      }
    }
  }

  function replaceAliases() {
    var fullMatch = arguments.length <= 0 ? undefined : arguments[0];
    var edgeCase = arguments.length <= 1 ? undefined : arguments[1];
    var alias = arguments.length <= 2 ? undefined : arguments[2];

    if (edgeCase) {
      return fullMatch;
    }

    var aliasEmoji = _aliases2.default[alias];
    return aliasEmoji || fullMatch;
  } // We need to execute several times `string.replace` for cases for such as ":):)"
  // As we are forced to match ":):" to check if it's a normal alias, the second colon is consumed and cannot match again


  function replaceAllAsciiAliases(textWithAsciiAliases) {
    var previousTextWithoutAsciiAliases = null;
    var textWithoutAsciiAliases = textWithAsciiAliases;

    while (previousTextWithoutAsciiAliases !== textWithoutAsciiAliases) {
      previousTextWithoutAsciiAliases = textWithoutAsciiAliases;
      textWithoutAsciiAliases = textWithoutAsciiAliases.replace(asciiAliasesRegex, replaceAsciiAliases);
    }

    return textWithoutAsciiAliases;
  }

  var replacedText = text;
  replacedText = replacedText.replace(aliasesRegex, replaceAliases);
  replacedText = replaceAllAsciiAliases(replacedText);
  replacedText = replacedText.replace(aliasesRegex, replaceAliases);
  return (0, _stringReplaceToArray2.default)(replacedText, unicodeEmojiRegex, replaceUnicodeEmoji);
}

function Emoji(_ref) {
  var text = _ref.text,
      onlyEmojiClassName = _ref.onlyEmojiClassName,
      _ref$options = _ref.options,
      options = _ref$options === undefined ? {} : _ref$options,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, ["text", "onlyEmojiClassName", "options", "className"]);

  function isOnlyEmoji(output) {
    if (output.length > 3) return false;

    for (var i = 0; i < output.length; i++) {
      if (typeof output[i] === "string") return false;
    }

    return true;
  }

  var output = toArray(text, options);
  var classes = (0, _classnames3.default)(className, _defineProperty({}, onlyEmojiClassName, isOnlyEmoji(output)));
  return _react2.default.createElement("span", _extends({}, rest, {
    className: classes
  }), output);
}

Emoji.propTypes = {
  text: _propTypes2.default.string,
  props: _propTypes2.default.object,
  onlyEmojiClassName: _propTypes2.default.string,
  options: _propTypes2.default.shape({
    baseUrl: _propTypes2.default.string,
    size: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    ext: _propTypes2.default.string,
    className: _propTypes2.default.string
  })
};